import { createTheme } from '@mui/material/styles'

export default createTheme({
  palette: {
    primary: {
      main: '#37b983'
    },
    secondary: {
      main: '#b4975a'
    }
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      'Open Sans',
      'Helvetica Neue',
      'Arial',
      'sans-serif',
      'Apple Color Emoji',
      'Segoe UI Emoji',
      'Segoe UI Symbol'
    ].join(','),
    fontSize: 14,
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightBold: 700
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        body1: {
          fontSize: 14,
          fontWeight: 400
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: '#aaa'
        },
        selectMenu: {
          borderRadius: 4,
          whiteSpace: 'wrap'
        },
        select: {
          '&:focus': {
            borderRadius: 4,
            backgroundColor: '#222'
          }
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottom: '1px solid #444'
          },
          '&&&&:hover:before': {
            borderBottom: '1px solid #666'
          },
          '&:after': {
            borderBottom: '2px solid #37b983'
          }
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottom: 'none'
          },
          '&&&&:hover:before': {
            borderBottom: 'none'
          },
          '&:after': {
            borderBottom: '2px solid #37b983'
          }
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: '#fff',
          fontSize: 14,
          fontWeight: 400,
          backgroundColor: '#222222',
          borderRadius: 4
        }
      }
    },

    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: 14,
          fontWeight: 600,
          letterSpacing: 0.4,
          borderRadius: 4,
          color: '#fff',
          backgroundColor: 'transparent',
          minWidth: 'none'
        },
        sizeSmall: {
          padding: '.5rem',
          fontSize: 12
        },
        sizeLarge: {
          padding: '1.5rem',
          fontSize: 14
        },
        outlined: {
          padding: '8px 16px'
        },
        text: {
          padding: '8px 16px'
        },
        textPrimary: {
          color: '#fff',
          backgroundColor: '#b4975a',
          '&:hover': {
            backgroundColor: '#967d48',
            '@media (hover:none)': {
              backgroundColor: '#967d48'
            }
          }
        },
        textSecondary: {
          color: '#fff',
          backgroundColor: '#333',
          '&:hover': {
            backgroundColor: '#444',
            '@media (hover:none)': {
              backgroundColor: '#444'
            }
          }
        }
      }
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#aaa',
          fontSize: 14,
          fontWeight: 400,
          '&$focused': {
            color: '#aaa'
          }
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: 12
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginRight: 0
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#282828',
          color: '#aaa'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: 14,
          fontWeight: 400
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        colorPrimary: {
          color: '#888',
          checked: {
            color: '#37b983'
          }
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          '&$selected': {
            backgroundColor: '#444',
            color: '#fff'
          }
        }
      }
    }
  }
})
